import { INTEGRATOR_ID } from '../config/environment-variables';
import {
  LOCAL_STORAGE_BUSINESS_START_TIME,
  LOCAL_STORAGE_ENDPOINT_ACCESS,
  LOCAL_STORAGE_MACHINE_ID,
  LOCAL_STORAGE_SESSION_EXPIRES_KEY,
  LOCAL_STORAGE_SESSION_ID,
  LOCAL_STORAGE_TAX_POPUP,
  LOCAL_STORAGE_USER_ID,
  logout,
} from './auth-actions';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { COLOR_PICKER_OPTIONS } from '../const/color-picker-const';
import { utcToZonedTime } from 'date-fns-tz';
import parseISO from 'date-fns/parseISO';

export const DASHBOARD_MACHINE_ID = 'dashboardMachineIds';
export const SWEDISH_TIME_ZONE = 'Europe/Stockholm';

export function headerConfig(additionalHeaders = {}) {
  return dispatch => {
    
    if (!hasAuthenticationHeaders()) {
      dispatch(logout());
    }
    
    return ({
      headers: {
        ...additionalHeaders,
        'SessionId': localStorage.getItem(LOCAL_STORAGE_SESSION_ID),
        'IntegratorId': INTEGRATOR_ID,
      },
    });
  };
}

export function setAuthenticationHeaders(sessionId, userId, sessionLifetime) {
  localStorage.setItem(LOCAL_STORAGE_SESSION_ID, sessionId);
  localStorage.setItem(LOCAL_STORAGE_USER_ID, userId);
  localStorage.setItem(LOCAL_STORAGE_SESSION_EXPIRES_KEY, sessionLifetime);
}

export function clearAuthenticationHeaders() {
  localStorage.removeItem(LOCAL_STORAGE_MACHINE_ID);
  localStorage.removeItem(LOCAL_STORAGE_SESSION_ID);
  localStorage.removeItem(LOCAL_STORAGE_USER_ID);
  localStorage.removeItem(LOCAL_STORAGE_SESSION_EXPIRES_KEY);
}

export function clearOtherDataStoredInLocalStorage() {
  localStorage.removeItem(DASHBOARD_MACHINE_ID);
  localStorage.removeItem(LOCAL_STORAGE_TAX_POPUP);
  localStorage.removeItem(LOCAL_STORAGE_BUSINESS_START_TIME);
  localStorage.removeItem(LOCAL_STORAGE_ENDPOINT_ACCESS);
}

export function hasAuthenticationHeaders() {
  const sessionId = localStorage.getItem(LOCAL_STORAGE_SESSION_ID);
  const userId = localStorage.getItem(LOCAL_STORAGE_USER_ID);
  const sessionExpires = localStorage.getItem(LOCAL_STORAGE_SESSION_EXPIRES_KEY);
  
  if (!sessionId || !userId || !sessionExpires) {
    return false;
  }
  
  let sessionExpiresDate = parseISO(sessionExpires);
  const nowUTC = new Date();
  const nowSwedishTime = utcToZonedTime(nowUTC, SWEDISH_TIME_ZONE);
  return nowSwedishTime <= sessionExpiresDate;
}

export function getUserId() {
  return localStorage.getItem(LOCAL_STORAGE_USER_ID);
}

export function getRandom8NumbersCode() {
  const possibleChars = '0123456789';
  let result = '';
  for (let i = 8; i > 0; --i) {
    result += possibleChars[Math.floor(Math.random() * possibleChars.length)];
  }
  return result;
}

export const printDocument = ({ printRef }) => {
  html2canvas(printRef.current, {
    windowWidth: printRef.current.offsetWidth,
    windowHeight: printRef.current.offsetHeight,
  }).then((canvas) => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF();
  
    const imgProperties = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
  
    pdf.addImage(imgData, 'PNG', 0, 10, pdfWidth, pdfHeight);
    pdf.save('report.pdf');
  });
};

export const getColorName = (hexValue) => {
  const colorOption = COLOR_PICKER_OPTIONS.find(option => option.value === hexValue.toUpperCase());
  return colorOption ? colorOption.name : '#ff0000';
};

export const isHexColor = (value) => {
  return /^#([0-9A-Fa-f]{3}){1,2}$/.test(value);
};